exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".selectedMath {\n  background-color: #b9d2f7e5; }\n\n.mathRenderer {\n  margin-left: 5px;\n  margin-right: 5px;\n  padding-left: 2px;\n  padding-right: 2px;\n  padding-top: 1px;\n  padding-bottom: 1px; }\n", ""]);

// exports
